module.exports = __webpack_public_path__ + "media/images/desktop/header-bookshelf-9e9d403a35d0925e0c009cce74495817.png";